// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__5D1PS","buttons":"styles_buttons__RhId2","title":"styles_title__T6VSK","content":"styles_content__E9TLR","close-button":"styles_close-button__CJM4Y"};